/**
 * Cognito configuration for Spinora
 * Set REACT_APP_COGNITO_USER_POOL_ID and REACT_APP_COGNITO_CLIENT_ID to enable Cognito auth
 */

export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
};

export const isCognitoConfigured = (): boolean =>
  Boolean(cognitoConfig.userPoolId && cognitoConfig.clientId);
